"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var KYC_COLOR_BY_STATUS = {
    PENDING: 'orange',
    NOT_VERIFIED: 'red',
    VERIFIED: 'green',
};
var KycStatus = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var data = (0, swr_hooks_1.useKYCStatus)().data;
    if (!(data === null || data === void 0 ? void 0 : data.status))
        return null;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat((data === null || data === void 0 ? void 0 : data.status) && (styles_module_scss_1.default === null || styles_module_scss_1.default === void 0 ? void 0 : styles_module_scss_1.default[KYC_COLOR_BY_STATUS === null || KYC_COLOR_BY_STATUS === void 0 ? void 0 : KYC_COLOR_BY_STATUS[String(data === null || data === void 0 ? void 0 : data.status)]])) },
        react_1.default.createElement("img", { src: "/img/icons/kyc/".concat(KYC_COLOR_BY_STATUS === null || KYC_COLOR_BY_STATUS === void 0 ? void 0 : KYC_COLOR_BY_STATUS[String(data === null || data === void 0 ? void 0 : data.status)], ".svg"), alt: "status" }),
        t(data === null || data === void 0 ? void 0 : data.status)));
};
exports.default = KycStatus;
